import { render, staticRenderFns } from "./pageEight.vue?vue&type=template&id=8273a77e&scoped=true&"
import script from "./pageEight.vue?vue&type=script&lang=js&"
export * from "./pageEight.vue?vue&type=script&lang=js&"
import style0 from "./pageEight.vue?vue&type=style&index=0&id=8273a77e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8273a77e",
  null
  
)

export default component.exports